import React from 'react';
import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import ReactTable from "../Components/ReactTable";

function IfpsMappingsUsageLog() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/getGcsFileByPath/?path=gs://spins-edp-${process.env.REACT_APP_ENV}-services/ifpsMappingsSyncLog/result.json&file_type=jsonl`
    const {data} = useServiceBase({endpointUrl});

    const columns = [
        {header: "run time", accessorKey: "date_time"},
        {header: "input path", accessorKey: "input_path"},
        {header: "output path", accessorKey: "output_path"},
        {header: "triggered By", accessorKey: "triggered_by"},
    ];
    return (
            <ReactTable
                filterable
                data={data}
                columns={columns}
                initialState={{pagination: {pageSize: 10}, sorting: [{id: "date_time", desc: true}]}}
            />
      );
}

export default IfpsMappingsUsageLog;
